import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

const useFetch = (url, cacheKey = null, shouldFetch = true) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(shouldFetch);
  const [error, setError] = useState(null);
  const userInfo = useSelector((state) => state.auth.user);
  // console.log({ userInfo, url });
  const token = localStorage.getItem('authToken');
  
  const fetchData = useCallback(async () => {
    if (!shouldFetch) {
      setLoading(false);
      return;
    }
// console.log({shouldFetch});
    try {
      const headers = {
        Authorization: `Bearer ${userInfo?.token || token}`,
        'Content-Type': 'application/json',
      };

      if (!url) {
        setData(null);
      } else {
        setLoading(true);
        const response = await fetch(url, { headers });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const resultData = await response.json();
        
        
        setData(resultData || null);

        if (cacheKey && resultData) {
          localStorage.setItem(cacheKey, JSON.stringify(resultData));
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [url, userInfo, cacheKey, shouldFetch]);

  useEffect(() => {
    // const isManualRefresh = (() => {
    //   if (performance.getEntriesByType('navigation').length > 0) {
    //     const navType = performance.getEntriesByType('navigation')[0].type;
    //     return navType === 'reload';
    //   }
    //   // fallback for older browsers
    //   return performance.navigation.type === 1;
    // })();
    const isManualRefresh = (() => {
        const entries = performance.getEntriesByType('navigation');
        if (entries.length > 0) {
          return entries[0].type === 'reload'; // ✅ modern way
        }
        return false; // fallback
      })();
      
    if (cacheKey && !isManualRefresh && shouldFetch) {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        setData(JSON.parse(cached));
        setLoading(false);
      } else {
        fetchData();
      }
    } else if (shouldFetch) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [fetchData, cacheKey, shouldFetch]);

  return { data, loading, error, refetch: fetchData };
};

export default useFetch;